module.exports = __webpack_public_path__ + "img/ontrack-fr-ca.2aac6833.jpg";